import { Pipe, PipeTransform } from '@angular/core';
import { Observable } from 'rxjs';
import { DocumentElementResponse } from 'src/openapi-client';
import { ElementContext } from './element-context';

@Pipe({
  name: 'element',
  standalone: true,
})
export class ElementPipe implements PipeTransform {
  constructor(private readonly elementContext: ElementContext) {}

  public transform(elementName: string): Observable<DocumentElementResponse | undefined> {
    return this.elementContext.getElement(elementName);
  }
}
